import { openDB } from 'idb';

export const initDB = async () => {
  return openDB('Web3AppDB', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('keys')) {
        db.createObjectStore('keys');
      }
    },
  });
};

export const saveIndexKey = async (key, value) => {
  const db = await initDB();
  await db.put('keys', value, key);
  return true;
};

export const getIndexKey = async (key) => {
  const db = await initDB();
  return await db.get('keys', key);
};
